module.exports = __webpack_public_path__ + "img/stone6.6b4a8ae8.png";